import { Box, Typography } from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

type Props = {
  readOnly: boolean;
  index: number;
};

const TesSalaryTableOrderIndicator = ({ readOnly, index }: Props) => (
  <Box display="flex" alignItems="center" gap={1}>
    {!readOnly && <DragIndicatorIcon color="action" />}
    <Typography color="text.secondary">{index + 1}</Typography>
  </Box>
);

export default TesSalaryTableOrderIndicator;
